module.exports = __webpack_public_path__ + "img/lacrosse.755b862f.svg";